import React from 'react';
import NotFound from '../assets/images/notFound.jpg';
import { Image } from 'antd';

export const CustomImage = ({ src, alt = 'Image', preview = true, style, width, ...rest }) => {
  const [imageSrc, setImageSrc] = React.useState(src);

  const handleError = () => {
    setImageSrc(NotFound);
  };

  return (
    <Image
      src={imageSrc}
      alt={alt}
      preview={preview}
      onError={handleError}
      style={{
        objectFit: 'cover',
        width: width || '100%',
        height: 'auto',
        ...style,
      }}
      {...rest}
    />
  );
};
